import Link from "flarum/components/Link";

export default (topQuestions, title, hasDropDown = true) => {
    const params = {
      include: "user,lastPostedUser,tags,firstPost",
      sort: "-commentCount",
    };
    if (!topQuestions) return null;
    return (
      <div className={ hasDropDown ? "PostStreamScrubber Dropdown App-titleControl" : null }>
        {!hasDropDown
          ? null
          : (
        <button className="Button Dropdown-toggle" data-toggle="dropdown">
          <span>{title}</span>
        </button>
            )}
        <div className={ hasDropDown ? "Dropdown-menu dropdown-menu" : null }>
          <div className="topQuestionsTitle">
            {title}
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
          </div>
          {!topQuestions
            ? null
            : topQuestions.map((discussion, i) => {
                const { id, title, comment_count, slug, participant_count } =
                  discussion;
                const curRoute = `/d/${id}-${slug}`;
                return (
                  <div
                    key={id}
                    data-id={id}
                    className="topDiscussionsMain-item"
                  >
                    <div>
                      <Link href={curRoute} title={title}>
                        {title}
                      </Link>
                    </div>
                    <ul className="topDiscussions-paramList">
                      <li className="topDiscussions-participant_count">
                        Подписчиков {participant_count}
                      </li>
                      <li className="topDiscussions-comment_count">
                        ответов {comment_count}
                      </li>
                    </ul>
                  </div>
                );
              })}
        </div>
      </div>
    );
  };
